class SizeChartDrawer extends HTMLElement {
  constructor() {
    super();
    
    // Wait for the element to be fully connected to the DOM
    if (this.isConnected) {
      this.initialize();
    } else {
      // If not connected yet, wait for it
      this.addEventListener('connectedCallback', () => this.initialize());
    }
  }

  initialize() {
    console.log('SizeChartDrawer: Initializing...', this.id);
    
    // Find the overlay that's closest to this drawer
    this.overlay = this.previousElementSibling;
    if (!this.overlay || !this.overlay.classList.contains('size-chart-drawer__overlay')) {
      // If no overlay found, look for one that's not already associated with another drawer
      const allOverlays = document.querySelectorAll('.size-chart-drawer__overlay');
      for (let overlay of allOverlays) {
        if (!overlay.dataset.assigned) {
          this.overlay = overlay;
          overlay.dataset.assigned = this.id;
          break;
        }
      }
    } else {
      this.overlay.dataset.assigned = this.id;
    }
    
    this.closeButton = this.querySelector('.size-chart-drawer__close');
    
    // Find the trigger button that's closest to this drawer
    this.trigger = this.closest('.size-guide')?.querySelector('[data-size-chart-drawer]');
    if (!this.trigger) {
      // If no trigger found in closest size-guide, look for one that's not already associated
      const allTriggers = document.querySelectorAll('[data-size-chart-drawer]');
      for (let trigger of allTriggers) {
        if (!trigger.dataset.assigned) {
          this.trigger = trigger;
          trigger.dataset.assigned = this.id;
          break;
        }
      }
    } else {
      this.trigger.dataset.assigned = this.id;
    }
    
    console.log('SizeChartDrawer: Found elements:', {
      id: this.id,
      overlay: this.overlay,
      closeButton: this.closeButton,
      trigger: this.trigger
    });
    
    this.bindEvents();
  }

  bindEvents() {
    console.log('SizeChartDrawer: Binding events', {
      trigger: this.trigger,
      closeButton: this.closeButton,
      overlay: this.overlay
    });
    
    if (this.trigger) {
      console.log('SizeChartDrawer: Adding click listener to trigger');
      this.trigger.addEventListener('click', (e) => {
        console.log('SizeChartDrawer: Trigger clicked!');
        e.preventDefault();
        this.open();
      });
    } else {
      console.warn('SizeChartDrawer: No trigger found');
    }
    
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.close());
    }
    
    if (this.overlay) {
      this.overlay.addEventListener('click', (e) => {
        // Only close if clicking directly on the overlay, not on its children
        if (e.target === this.overlay) {
          this.close();
        }
      });
    }

    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.classList.contains('is-open')) {
        this.close();
      }
    });
  }

  open() {
    console.log('SizeChartDrawer: Opening drawer');
    this.classList.add('is-open');
    document.body.classList.add('drawer-open');
    document.body.style.overflow = 'hidden';
    
    // Focus the drawer for accessibility
    this.focus();
    console.log('SizeChartDrawer: Drawer opened');
  }

  close() {
    this.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
    document.body.style.overflow = '';
    
    // Return focus to the trigger button
    if (this.trigger) {
      this.trigger.focus();
    }
  }
}

customElements.define('size-chart-drawer', SizeChartDrawer);

// Debug: Log when the component is defined
console.log('SizeChartDrawer component defined');

// Debug: Check if elements exist after DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  console.log('DOM loaded, checking for size chart elements:');
  console.log('Size chart drawers:', document.querySelectorAll('size-chart-drawer'));
  console.log('Size chart triggers:', document.querySelectorAll('[data-size-chart-drawer]'));
  console.log('Size chart overlays:', document.querySelectorAll('.size-chart-drawer__overlay'));
});

// Fallback: Also check after a short delay to ensure everything is rendered
setTimeout(() => {
  console.log('Delayed check for size chart elements:');
  console.log('Size chart drawers:', document.querySelectorAll('size-chart-drawer'));
  console.log('Size chart triggers:', document.querySelectorAll('[data-size-chart-drawer]'));
  console.log('Size chart overlays:', document.querySelectorAll('.size-chart-drawer__overlay'));
}, 1000);
